import React from "react";
import "./stepThree.scss";

// Imagens:
import ImgStepThree from "../../../../assets/homeImgs/stepThree.png";
import { useTranslation } from "react-i18next";

const StepThree = () => {
  const { t } = useTranslation()

  return (
    <div className="container-step-three">

      <div className="img-step-three">
        <img src={ImgStepThree} alt="imagem step um" />
      </div>
      <div className="texts-step-three">
        <h1>3. {t("home.step3.title")}</h1>
        <p>{t("home.step3.section_text")}</p>
        {/* <button id="btn-step-three">CONFIRA!</button> */}
      </div>
    </div>
  );
};
export default StepThree;
